import React from "react";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";

export const AM_OBJ = {value: 'am', label: 'AM'};
export const PM_OBJ = {value: 'pm', label: 'PM'};

export const ALL_SESSION_OBJ = {value: 'all', label: 'All Day'}

const DropdownAMPM = ({control, name, onChange, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, options}) =>
{

    return (
        <div>
            <CommonDropdown items={options} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} />
        </div>
    )
}

export default DropdownAMPM;